/*
 * @Author: your name
 * @Date: 2021-04-21 15:29:50
 * @LastEditTime: 2021-04-25 10:00:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/business/contract/attachment/api.js
 */
import request from '@/router/axios';

//全部合同附件列表
export function contractAttachedFileSealList(query) {
  return request({
    url: '/api/contractAttachedFile/seal/page',
    method: 'get',
    params: query
  })
}
//盖章
export function sealcContractAttachedFile(obj) {
  return request({
    url: '/api/contractAttachedFile/seal' ,
    method: 'put',
    params: obj
  })
}



//评论
export function commentContractAttachedFile(obj) {
  return request({
    url: '/api/contractAttachedFile/comment' ,
    method: 'put',
    params: obj
  })
}

//批量盖章
export function batchSealContractAttachedFile(obj) {
  return request({
    url: '/api/contractAttachedFile/batchSeal' ,
    method: 'put',
    params: obj
  })
}

